import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {CONFIG} from "../../../app/config";
import {TStatusBar, Util} from "../../../app/util";
import {TAction, TProdutoTipo, TImageModel} from "../../../app/enum";
import {WebstorService} from "../../../providers/webstor-service";
import {LogadoService} from "../../../providers/logado-service";


@Component({
    selector: 'page-cluster-menu',
    templateUrl: 'cluster-menu.html',
    providers: [WebstorService]
})

export class ClusterMenuPage {

    TImageModel: any = TImageModel;
    TProdutoTipo: any = TProdutoTipo;

    config: any;
    logado: any;

    etapa: number;
    mlist: TImageModel;

    homeb: boolean;

    change: any;

    clusters: any;
    indexCA: number;
    indexCB: number;
    indexCC: number;
    indexBL: number;

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public util: Util,
                public logadoService: LogadoService, public webstorService: WebstorService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.etapa = this.navParams.get('etapa');
        this.mlist = this.navParams.get('mlist');
        this.homeb = this.navParams.get('homeb');

        this.change = this.navParams.get('change');

        this.clusters = this.navParams.get('clusters');
        this.indexCA = this.navParams.get('indexCA');
        this.indexCB = this.navParams.get('indexCB');
        this.indexCC = this.navParams.get('indexCC');
        this.indexBL = this.navParams.get('indexBL');

        this.clusterLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    clusterLoad() {

        if (this.etapa > 1) return;

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.cluster(TAction.acLoad)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.clusters = data.Clusters,
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    getTitle() {

        if (this.etapa == 0) return 'Cluster';
        if (this.etapa == 1) return 'Cluster';
        if (this.etapa == 2) return this.clusters[this.indexCA].Clusters[this.indexCB].ClusterNome;
        if (this.etapa == 3) return this.clusters[this.indexCA].Clusters[this.indexCB].Clusters[this.indexCC].Blendeds[this.indexBL].BlendedNome;
        //if (this.etapa == 3) return this.clusters[this.indexCA].ClusterNome;
        //if (this.etapa == 4) return 'Serviço';

    }

    grupoSave() {

    }

    clusterZero() {

        this.etapa = (this.etapa == 0 ? 1 : 0);

    }

    clusterMenu(index1, index2, produto?) {

        if (this.viewCtrl.isOverlay) {

            if (this.etapa == 1) {
                this.indexCA = index1;
                this.indexCB = index2;
            }

            if (this.etapa == 2) {
                this.indexCC = index1;
                this.indexBL = index2;
            }

            //Retorna o selecionado
            if (this.etapa == 3) {
                let data = this.util.deepCopy(this.clusters[this.indexCA].Clusters[this.indexCB].Clusters[this.indexCC].Blendeds[this.indexBL]);
                data.Produto = produto;
                delete data.Produtos;
                this.dismiss({blended: data});
                return;
            }

            this.etapa += 1;
            this.clusterLoad();
            return;

        }

        let object: any;
        if (this.etapa == 1) object = {etapa: 2, homeb: false, clusters: this.clusters, indexCA: index1, indexCB: index2};
        if (this.etapa == 2) object = {etapa: 3, homeb: false, clusters: this.clusters, indexCA: this.indexCA, indexCB: this.indexCB, indexCC: index1, indexBL: index2};
        this.navCtrl.push(ClusterMenuPage, object);

    }

    dismiss(data?) {

        if (this.viewCtrl.isOverlay && this.etapa > 1 && !data) {
            this.etapa -= 1;
            this.clusterLoad();
            return;
        }

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss(data);
            return;
        }

        this.navCtrl.pop();

    }
}



// WEBPACK FOOTER //
// ./src/pages/sync/cluster-menu/cluster-menu.ts